import { createAsyncThunk } from '@reduxjs/toolkit';
import { ImageDocumentStoreItem, RetrievedDocumentReferenceLink } from '@v2/components/imageHandling/types/types.d';
import { AppDispatch } from '@store/types';
import { setUpdatingImageMetadataInProgress, updateImageDocumentInDict } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { updateImageMetadata } from './updateImageMetadata';

interface HandleRemoveAttachmentPayload {
  img: ImageDocumentStoreItem;
  attachmentToRemove: RetrievedDocumentReferenceLink;
}

export const handleRemoveAttachment = createAsyncThunk<void, HandleRemoveAttachmentPayload, { dispatch: AppDispatch }>(
  'imageHandlingV2/handleRemoveAttachment',
  async ({ img, attachmentToRemove }, { dispatch }) => {
    dispatch(setUpdatingImageMetadataInProgress(true));

    if (attachmentToRemove && img && img.links) {
      // Remove attachment from local state
      const newLinks = img.links.filter(
        (l) => !(l.scopeId === attachmentToRemove.scopeId && l.scopeReferenceId === attachmentToRemove.scopeReferenceId)
      ) as RetrievedDocumentReferenceLink[];
      const updatedImg = { ...img, links: newLinks };
      dispatch(updateImageDocumentInDict({ documentId: updatedImg.documentId!, updatedImageDocument: updatedImg }));

      dispatch(setUpdatingImageMetadataInProgress(false));

      // Prepare backend data - send all links with their current state
      const backendData = {
        documentId: img.id,
        documentLinks: [
          // Keep existing links as activated
          ...newLinks.map((l) => ({
            scopeId: l.scopeId,
            scopeReferenceId: l.scopeReferenceId,
            scopeReferenceName: l.scopeReferenceName,
            isFavorite: l.isFavorite,
            isActivated: true,
            isFavoriteChanged: false,
          })),
          // Mark the removed link as deactivated
          {
            ...attachmentToRemove,
            isActivated: false,
            isFavoriteChanged: false,
          },
        ],
        documentTags: img?.documentTag ? [img.documentTag] : null,
      };

      await dispatch(updateImageMetadata({ data: backendData }));
    }
  }
);
